export default __webpack_public_path__ + "static/cs-solution-architecture--mobile-7f5150919e19ed10fcae536c9fd45a43.png";